import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const bitdefender = defineConnector({
  identifier: "bitdefender",
  name: "Bitdefender",
  tagLine: "Endpoint protection and security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ ACCESS_URL }) => domainToRegex(ACCESS_URL),
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: "",
    }),
  steps: [
    {
      title: "Create a Bitdefender GravityZone API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the GravityZone console and navigate to **My Account > API keys**. Click **Add** to create a new API key. You’ll also need your Access URL, which is shown at the top of the API keys page.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "url",
          label: "Access URL",
          placeholder: "https://cloud.gravityzone.bitdefender.com/api",
          required: true,
          target: { kind: "configuration", field: "ACCESS_URL" },
          helperText: "The GravityZone API access URL",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "username" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `${configuration.ACCESS_URL}/v1.0/jsonrpc/general`,
  },
  publicEnvVars: ({ ACCESS_URL }) => ({
    BITDEFENDER_ACCESS_URL: ACCESS_URL || "",
  }),
});
